import { useEffect } from "react"
import { isBrowser } from "@utils/Utils"

export const debounce = (func, wait, immediate) => {
  let timeout = null

  return function () {
    const context = this
    const args = arguments

    const later = () => {
      timeout = null

      if (!immediate) {
        func.apply(context, args)
      }
    }

    const callNow = immediate && !timeout

    clearTimeout(timeout)

    timeout = setTimeout(later, wait)

    if (callNow) {
      func.apply(context, args)
    }
  }
}

export const waitForVariable = (name, value, func) => {
  const interval = setInterval(() => {
    if (window[name] !== null && (value === null || window[name] === value)) {
      func()
      clearInterval(interval)
    }
  }, 100)
}

const GTM = () => {
  useEffect(() => {
    let distanceScrolled = -1
    let distanceThreshold = [
      { threshold: 0, value: "Baseline", sent: false },
      { threshold: 25, value: "25%", sent: false },
      { threshold: 50, value: "50%", sent: false },
      { threshold: 75, value: "75%", sent: false },
      { threshold: 100, value: "100%", sent: false },
    ]

    const scrollDepth = () => {
      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop
      let progress = Math.round(
        (scrollTop / (document.body.scrollHeight - window.innerHeight)) * 100
      )

      if (isNaN(progress)) progress = 0

      if (progress > distanceScrolled) {
        distanceScrolled = progress

        for (let i = 0; i < distanceThreshold.length; i++) {
          const status = distanceThreshold[i].sent
          const threshold = distanceThreshold[i].threshold
          const value = distanceThreshold[i].value

          if (!status && progress >= threshold) {
            if ("dataLayer" in window) {
              window.dataLayer.push({
                event: "gatsbyScroll",
                gatsbyScrollDistance: value,
              })
              distanceThreshold[i].sent = true
            }
          }
        }
      }
    }
    const scrollListener = debounce(scrollDepth, 18)

    document.addEventListener("scroll", scrollListener)

    scrollDepth()

    return () => {
      distanceScrolled = -1

      for (let i = 0; i < distanceThreshold.length; i++) {
        distanceThreshold[i].sent = false
      }

      document.removeEventListener("scroll", scrollListener)
    }
  }, [])
  return null
}

export default GTM

export const gtmLeavingModalClick = url => {
  isBrowser &&
    window.dataLayer.push({
      event: "LeavingModalContinue",
      url: url,
    })
}

export const gtmLeavingModalCancel = url => {
  isBrowser &&
    window.dataLayer.push({
      event: "LeavingModalCancel",
      url: url,
    })
}

export const gtmFormSubmit = () => {
  isBrowser &&
    window.dataLayer.push({
      event: "Form Submission",
    })
}

export const gtmVideoPlay = videoTitle => {
  isBrowser &&
    window.dataLayer.push({
      event: "Video-Plays",
      eventAction: videoTitle,
    })
}

export const gtmVideoSeconds = (videoTitle, seconds) => {
  isBrowser &&
    window.dataLayer.push({
      event: "Video–Interval–Seconds",
      eventAction: videoTitle,
      eventLabel: seconds,
    })
}

export const gtmVideoPercentage = (videoTitle, percentage) => {
  isBrowser &&
    window.dataLayer.push({
      event: "Video–Interval–Percent",
      eventAction: videoTitle,
      eventLabel: percentage,
    })
}

export const gtmFieldCompletion = (formName, formField) => {
  isBrowser &&
    window.dataLayer.push({
      event: "FieldCompletion",
      eventAction: formName,
      eventLabel: formField,
    })
}
